// F8 — shared per-item status badge, so the party-surface "request view"
// slide-out renders a package item's status identically to the package-detail
// page. Review loop — label and tone come from the one staff label map; the
// raw CollectionItemStatus code never renders.

import { Badge } from "@/design-system/components/ui";
import type { CollectionItemStatus } from "@/api/collectionPackages";
import { ITEM_STATUS } from "@/components/Collection/collectionStatusLabels";

export function ItemStatusBadge({ status }: { status: CollectionItemStatus }) {
  const s = ITEM_STATUS[status];
  return <Badge status={s?.tone ?? "draft"}>{s?.label ?? "—"}</Badge>;
}
